/* eslint-disable react/jsx-props-no-spreading */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntersectionObserver } from '../../hooks/useObserver';

import * as AppPropTypes from '../../lib/PropTypes';
import Html from './Html';
import Image from './Image';
import IntersectingVideo from '../blocks/employee/IntersectingVideo';

import styles from '../../../styles/partials/pill.module.scss';

const propTypes = {
    title: PropTypes.string,
    body: PropTypes.string,
    colors: AppPropTypes.colors,
    image: AppPropTypes.image,
    video: AppPropTypes.video,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    body: null,
    colors: null,
    image: null,
    video: null,
    className: null,
};

const Pill = ({ title, body, colors, image, video, className }) => {
    const {
        ref,
        entry: { isIntersecting = false },
    } = useIntersectionObserver({ rootMargin: '-15%' });

    const { type: colorType = null, colors: customColors = [] } = colors || {};

    const colorStyles = useMemo(() => {
        if (colorType === 'color') return { backgroundColor: customColors[0] };
        if (colorType === 'gradient') {
            const colorStops = customColors.map((color) => `${color}`);
            return {
                backgroundImage: `linear-gradient(to right,  ${colorStops.join(', ')}, ${
                    colorStops[0]
                })`,
            };
        }
        return null;
    }, [colorType, customColors]);

    return (
        <div
            ref={ref}
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            style={{
                opacity: `${isIntersecting ? 1 : 0}`,
            }}
        >
            <div className={styles.inner} style={colorStyles}>
                <div className={styles.media}>
                    {video !== null ? (
                        <IntersectingVideo
                            src={video.url}
                            muted
                            loop
                            autoPlay
                            className={styles.video}
                        />
                    ) : (
                        <Image media={image} fit="cover" size="small" className={styles.image} />
                    )}
                </div>
                <div className={styles.content}>
                    {title !== null ? <div className={styles.title}>{title}</div> : null}
                    <Html className={styles.description} body={body} />
                </div>
            </div>
        </div>
    );
};

Pill.propTypes = propTypes;
Pill.defaultProps = defaultProps;

export default Pill;
